import React from 'react';
import ActionDialog from './ActionDialog';

interface ErrorModalProps {
  isOpen: boolean;
  title?: string;
  message: string;
  onClose: () => void;
}

/**
 * An error, in the app's one dialog.
 *
 * This used to be its own overlay: no portal, no Escape, no dialog role, and a
 * z-index of 9999 chosen to win an argument with the rest of the ladder.
 * `ActionDialog` is the owner of "the outcome of an action" and already has all
 * of that, so this is now a thin call to it (docs/DESIGN.md).
 *
 * The NAME and the import path stay. Five callers use them, and
 * `ConfirmedOrdersPage.errors.test.tsx` pins that this is the component that
 * reports a failure there rather than an `alert`.
 *
 * The list-per-line behaviour survives the move: several callers pass a list —
 * the confirmation gate's blockers, one per bad line — and ActionDialog's
 * summary sets `whitespace-pre-line`, exactly as this file used to.
 */
const ErrorModal: React.FC<ErrorModalProps> = ({ isOpen, title = 'Error', message, onClose }) => (
  <ActionDialog
    isOpen={isOpen}
    tone="error"
    title={title}
    summary={message}
    onClose={onClose}
    confirmLabel="Close"
  />
);

export default ErrorModal;
